import PropTypes from 'prop-types';
import { useCallback, useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router';
// TODO: Remove this code when the next version of React-Router (not v6) includes usePrompt and useBlocker.

// eslint-disable-next-line no-secrets/no-secrets
/**
 * These hooks re-implement the now removed useBlocker and usePrompt hooks in 'react-router'.
 * Source: https://gist.github.com/MarksCode/64e438c82b0b2a1161e01c88ca0d0355
 */

/**
 * Blocks all navigation attempts. This is useful for preventing the page from
 * changing until some condition is met, like saving form data.
 *
 * @param  confirmExit
 * @param  when
 * @see https://reactrouter.com/api/useBlocker
 */
function useConfirmExit(confirmExit, when = true) {
    const { navigator } = useContext(NavigationContext);

    useEffect(() => {
        if (!when) {
            return () => {};
        }

        const { push } = navigator;

        // eslint-disable-next-line react-hooks/immutability
        navigator.push = (...args) => {
            const result = confirmExit();
            if (result !== false) {
                push(...args);
            }
        };

        return () => {
            navigator.push = push;
        };
    }, [navigator, confirmExit, when]);
}

/**
 * Prompts the user with an Alert before they leave the current screen.
 *
 * @param  message
 * @param  when
 */
export function usePrompt(message, when = true) {
    useEffect(() => {
        if (when) {
            window.onbeforeunload = () => message;
        }

        return () => {
            window.onbeforeunload = null;
        };
    }, [message, when]);

    const confirmExit = useCallback(() => {
        // eslint-disable-next-line no-alert
        const confirm = window.confirm(message);
        return confirm;
    }, [message]);
    useConfirmExit(confirmExit, when);
}

export const UnsavedChangesPrompt = ({ message, when }) => {
    usePrompt(message, when);
    return null;
};
UnsavedChangesPrompt.propTypes = {
    message: PropTypes.string.isRequired,
    when: PropTypes.bool.isRequired,
};
